import { useCallback, useEffect, useState } from 'react';

// Should align with the `_variables.scss` file
const TABLET = 559;
const DESKTOP = 1025;

const getScreenType = () => {
  const { innerWidth: width } = window;
  return {
    isMobile: width < TABLET,
    isTablet: width >= TABLET && width < DESKTOP,
    isDesktop: width >= DESKTOP,
    isMobileOrTablet: width < DESKTOP,
    viewportWidth: width,
  };
};

export const useDimensions = () => {
  const [dimensions, setDimensions] = useState(getScreenType());

  const handleResize = useCallback(() => {
    setDimensions(getScreenType());
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  return dimensions;
};
